import { z } from 'zod';

export const TenantBqSyncTriggerSchema = z.enum(['MANUAL', 'SCHEDULED']);
export type TenantBqSyncTrigger = z.infer<typeof TenantBqSyncTriggerSchema>;

export const TenantBqSyncRunStatusSchema = z.enum(['RUNNING', 'SYNCED', 'PARTIAL', 'FAILED']);
export type TenantBqSyncRunStatus = z.infer<typeof TenantBqSyncRunStatusSchema>;

export const TenantBqSyncRunSchema = z.object({
  id: z.string().min(1),
  tenantId: z.string().min(1),
  trigger: TenantBqSyncTriggerSchema,
  triggeredByUserId: z.string().nullable(),
  startedAt: z.string().datetime(),
  finishedAt: z.string().datetime().nullable(),
  status: TenantBqSyncRunStatusSchema,
  productsAdded: z.number().int(),
  productsRemoved: z.number().int(),
  productTypesAdded: z.number().int(),
  productTypesRemoved: z.number().int(),
  industriesAdded: z.number().int(),
  industriesRemoved: z.number().int(),
  errorCode: z.string().nullable(),
  errorMessage: z.string().nullable(),
});
export type TenantBqSyncRun = z.infer<typeof TenantBqSyncRunSchema>;

export const TenantBqSyncRunsListSchema = z.object({
  runs: z.array(TenantBqSyncRunSchema),
  totalCount: z.number().int().nonnegative(),
});
export type TenantBqSyncRunsList = z.infer<typeof TenantBqSyncRunsListSchema>;

/** HH:MM in UTC for the daily auto-sync window. */
export const BqAutoSyncTimeUtcSchema = z
  .string()
  .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Expected HH:MM in UTC');

export const TenantBqSyncSettingsSchema = z.object({
  bqAutoSyncEnabled: z.boolean(),
  bqAutoSyncTimeUtc: BqAutoSyncTimeUtcSchema,
  bqSyncFailureNotifyUserId: z.string().nullable(),
  bqSyncFailureSlackAlertEnabled: z.boolean(),
  bqCatalogAsOfAt: z.string().datetime().nullable(),
});
export type TenantBqSyncSettings = z.infer<typeof TenantBqSyncSettingsSchema>;

export const AdminUpdateTenantBqSyncSettingsSchema = z.object({
  bqAutoSyncEnabled: z.boolean().optional(),
  bqAutoSyncTimeUtc: BqAutoSyncTimeUtcSchema.optional(),
  bqSyncFailureNotifyUserId: z.string().cuid().nullable().optional(),
  bqSyncFailureSlackAlertEnabled: z.boolean().optional(),
});
export type AdminUpdateTenantBqSyncSettings = z.infer<typeof AdminUpdateTenantBqSyncSettingsSchema>;

export const TenantSyncRequestedPayloadSchema = z.object({
  tenantId: z.string().min(1),
  trigger: TenantBqSyncTriggerSchema.optional(),
  triggeredByUserId: z.string().cuid().optional(),
});
